import React from "react";
import Main from "./components/Main";

const App = () =>{
    return(
        <div>
            <Main />
        </div>
    )
}

export default App;